import { getCustomFields } from "@/services/customFields.service";
import { timedOrdersFetch } from "@/utils/ordersPerfLog";
import { useQuery } from "@tanstack/vue-query";
import { computed, MaybeRefOrGetter, toValue } from "vue";

const REFERENCE_STALE_MS = 5 * 60 * 1000;

export default function useCustomFields(options?: { enabled?: MaybeRefOrGetter<boolean> }) {
  const {
    data: customFields,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["customFields"],
    queryFn: () => timedOrdersFetch("customFields", () => getCustomFields()),
    staleTime: REFERENCE_STALE_MS,
    refetchOnMount: false,
    enabled: computed(() => (options?.enabled === undefined ? true : !!toValue(options.enabled))),
  });
  return {
    customFields,
    isLoading,
    isError,
    error,
  };
}
